export const formStructure = [
  [
    {
      name: 'nomeTag',
      label: 'Nome da Tag',
      placeholder: 'Digite o nome da tag',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 },
      required: true,
      maxLength: 120,
      validation: { required: 'Nome da tag e obrigatorio' },
    },
    {
      name: 'descricao',
      label: 'Descricao',
      placeholder: 'Descreva a tag da ouvidoria',
      component: 'FormField',
      type: 'textarea',
      rows: 4,
      colProps: { md: 6 },
      required: true,
      maxLength: 500,
      validation: { required: 'Descricao e obrigatoria' },
    },
  ],
  [
    {
      name: 'prioridade',
      label: 'Prioridade',
      placeholder: 'Selecione',
      component: 'SearchSelect',
      isMulti: false,
      options: [
        { value: 'true', label: 'Sim' },
        { value: 'false', label: 'Nao' },
      ],
      colProps: { md: 6 },
      required: true,
      validation: { required: 'Prioridade e obrigatoria' },
    },
  ],
];

export const formSections = initialValues => [
  {
    title: `Detalhes da Tag ${initialValues.nomeTag || ''}`,
    rows: [0, 1],
  },
];

export const validateForm = values => {
  const errors = {};

  if (!values?.nomeTag || String(values.nomeTag).trim().length === 0) {
    errors.nomeTag = 'Nome da tag e obrigatorio';
  }

  if (!values?.descricao || String(values.descricao).trim().length === 0) {
    errors.descricao = 'Descricao e obrigatoria';
  }

  if (!values?.prioridade) {
    errors.prioridade = 'Prioridade e obrigatoria';
  }

  return errors;
};
